import {
  createPublicClient,
  createWalletClient,
  custom,
  http,
  type Abi,
  type Address,
  type EIP1193Provider,
  type Hex,
  type WriteContractParameters
} from "viem";
import { robinhoodTestnet } from "../config";

declare global {
  interface Window {
    ethereum?: EIP1193Provider;
  }
}

export const publicClient = createPublicClient({
  chain: robinhoodTestnet,
  transport: http(robinhoodTestnet.rpcUrls.default.http[0])
});

export interface WalletSession {
  account: Address;
  write(input: {
    address: Address;
    abi: Abi;
    functionName: string;
    args?: readonly unknown[];
  }): Promise<Hex>;
}

export async function connectWallet(): Promise<WalletSession> {
  if (!window.ethereum) throw new Error("No injected wallet found");
  const wallet = createWalletClient({ chain: robinhoodTestnet, transport: custom(window.ethereum) });
  const [account] = await wallet.requestAddresses();
  if (!account) throw new Error("Wallet did not return an account");
  try {
    await wallet.switchChain({ id: robinhoodTestnet.id });
  } catch {
    await wallet.addChain({ chain: robinhoodTestnet });
    await wallet.switchChain({ id: robinhoodTestnet.id });
  }
  return {
    account,
    async write(input) {
      const hash = await wallet.writeContract({
        ...input,
        account,
        chain: robinhoodTestnet
      } as WriteContractParameters);
      await publicClient.waitForTransactionReceipt({ hash });
      return hash;
    }
  };
}
